import React, { useState, useEffect } from "react";
import { useAuthCheck } from "../components/Auth";
import { api } from "../components/Api";
import { useNavigate } from "react-router-dom";

function Home() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [attempts, setAttempts] = useState(0); // compteur de tentatives

    const { checkToken } = useAuthCheck();
    const navigate = useNavigate();
    const token = localStorage.getItem("token");

    useEffect(() => {
        checkToken();
    }, [checkToken]);

    const buttons = [
        { label: "Ajouter un Produit", path: "/add-product", bg: "bg-blue-400", hover: "hover:bg-blue-500" },
        { label: "Ajouter une Carte / Booster", path: "/add-unity_card", bg: "bg-blue-400", hover: "hover:bg-blue-500" },
        { label: "Liste des Produits", path: "/all-list", bg: "bg-teal-400", hover: "hover:bg-teal-500" },
        { label: "Liste des Cartes / Boosters", path: "/unity_card-list", bg: "bg-teal-400", hover: "hover:bg-teal-500" },
        { label: "", path: "/", bg: "bg-white-400", hover: "hover:bg-white-500" },
        { label: "", path: "/", bg: "bg-white-400", hover: "hover:bg-white-500" },
        { label: "Produits Vendus", path: "/sold-list", bg: "bg-red-400", hover: "hover:bg-red-500" },
        { label: "Cartes / Boosters Vendus", path: "/sold-unity_card", bg: "bg-red-400", hover: "hover:bg-red-500" },
    ];

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage("");

        try {
            const res = await api.post("/login", { email, password });
            localStorage.setItem("token", res.data.token);
            window.location.reload();
        } catch (err) {
            console.error(err);
            setMessage("Erreur lors de la connexion. Vérifiez vos identifiants.");
            const newAttempts = attempts + 1;
            setAttempts(newAttempts);
            if (newAttempts >= 5) {
                window.location.href = "https://valcards.fr/"; // redirection externe
            }
        } finally {
            setLoading(false);
        }
    };

    const handleForgotPassword = async () => {
        if (!email) return alert("Veuillez saisir votre email pour récupérer le mot de passe.");
        setLoading(true);
        setMessage("");

        try {
            await api.post("/forgot-password", { email });
            setMessage("Email envoyé !");
        } catch (err) {
            console.error(err);
            setMessage("L'email ne correspond pas.");
        } finally {
            setLoading(false);
        }
    };

    // Si l'utilisateur est déjà connecté, ne pas afficher le formulaire
    if (token) {
        return (
            <div>
                <h1 className="text-2xl font-bold text-center mt-20 dark:text-white">
                    Vous êtes connecté
                </h1>
                <div className="container mx-auto p-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {buttons.map((btn, idx) => (
                            <button
                                key={idx}
                                onClick={() => navigate(btn.path)}
                                className={`${btn.bg} ${btn.hover} text-black font-bold rounded p-6 m-4`}
                            >
                                {btn.label}
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="container mx-auto max-w-md mt-20 p-6 bg-white text-black border rounded shadow">
            <h1 className="text-2xl font-bold mb-6 text-center">Connexion</h1>
            <form onSubmit={handleLogin} className="space-y-4">
                <div>
                    <label className="block mb-1 font-medium">Email</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="w-full border p-2 rounded"
                        required
                    />
                </div>
                <div>
                    <label className="block mb-1 font-medium">Mot de passe</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="w-full border p-2 rounded"
                        required
                    />
                </div>
                <button
                    type="submit"
                    disabled={loading}
                    className="w-full bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                >
                    {loading ? "Connexion..." : "Se connecter"}
                </button>
            </form>

            {message && (
                <div className="mb-4 p-2 my-4 bg-green-100 text-green-700 rounded">{message}</div>
            )}

            <div className="mt-4 text-center">
                <button
                    onClick={handleForgotPassword}
                    className="text-blue-500 hover:underline text-sm"
                    disabled={loading}
                >
                    Mot de passe oublié ?
                </button>
            </div>
        </div>
    );
}

export default Home;
